export default {
	namespaced: true,
	state: {
		id: null,
		name: "",
		icon: false,
		coverage_limits: [],
		deductible_categories: [],
		addons: [],
	},
	getters: {
		addons: (state, getters, rootState) => Object.values(rootState.global.api.data.addons).filter(
			(addon) => addon.type === state.id
		),
		hasPlan: (state, getters, rootState) => typeof rootState.game.plans[state.id] !== "undefined",
	},
};
